<template>
  <Checkbox
    :class="classes"
    :value="value"
    :label="label"
    :disabled="disabled"
    :indeterminate="indeterminate"
    :size="size"
    @input="onInput"
    @on-change="onChange"
  >
    <slot></slot>
  </Checkbox>
</template>

<script>
const prefixCls = "u-checkbox";
export default {
  name: "checkbox",
  props: {
    type: {
      type: String,
      default: "default"
    },
    value: {
      type: [String, Number, Boolean]
    },
    label: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: [String],
    trueValue: [String, Boolean, Number],
    falseValue: [String, Boolean, Number]
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.type}`
      ];
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    onChange(value) {
      this.$emit("on-change", value);
    }
  }
};
</script>
